import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "./gmao";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);
  const register = useCallback(async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  }, []);
  const logout = useCallback(async (reason) => {
    try {
      await api.post("/auth/logout", null, reason ? { params: { reason } } : undefined);
    } catch (err) {
      // la sesión local se limpia igualmente; registramos para no ocultar fallos
      if (process.env.NODE_ENV === "development") console.warn("Logout request failed; clearing local session anyway.", err);
    }
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, setUser, login, register, logout }), [user, login, register, logout]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
